export const PrerequisitesJrFrontEnd = {
  
  studyHours: "2 με 3 ώρες διαθέσιμες την ημέρα για μελέτη",
  programDuration: "Η πιο βασική προϋπόθεση είναι η κατανόηση, ότι είναι ένα υψηλού επιπέδου, εξάμηνο πρόγραμμα σπουδών, όπου για να μπορέσεις να το παρακολουθήσεις, πρέπει να αφιερώσεις χρόνο, αληθινή προσπάθεια και συστηματικότητα.",
  programmingKnowledge: "Προηγούμενη εμπειρία στον προγραμματισμό είναι χρήσιμη αλλά όχι τελείως απαραίτητη"
}
export const PrerequisitesAngularFramework = {
  
  studyHours: 'Διαθέσιμος χρόνος για μελέτη',
  programDuration:
    '',
  programmingKnowledge:
    'Γνώση Javascript, HTML, CSS',
};
export const PrerequisitesAI = {
 
  studyHours: "2 με 3 ώρες διαθέσιμες την ημέρα για μελέτη",
  programDuration: "Βασική προυπόθεση για την παρακολούθηση του συγκεκριμένου Bootcamp είναι η γνώση των τεχνολογιών HTML, CSS και Javascript. Για τον λόγο αυτό οι υποψήφιοι σπουδαστές του προγράμματος θα πρέπει να ολοκληρώσουν με επιτυχία ένα quiz. Για τη επιτυχή ολοκληρωση του προγράμματος θα πρέπει να αφιερώσεις χρόνο, αληθινή προσπάθεια και συστηματικότητα.",
  programmingKnowledge: "....."
}

export const PrerequisitesQaEngineer = {
  
  studyHours: "4 με 6 ώρες διαθέσιμες την εβδομάδα για μελέτη",
  programDuration: "Η πιο βασική προϋπόθεση είναι η κατανόηση, ότι είναι ένα υψηλού επιπέδου, δίμηνο πρόγραμμα σπουδών, όπου για να μπορέσεις να το παρακολουθήσεις, πρέπει να αφιερώσεις χρόνο, αληθινή προσπάθεια και συστηματικότητα.",
  programmingKnowledge:"Προηγούμενη εμπειρία στον προγραμματισμό είναι χρήσιμη αλλά όχι τελείως απαραίτητη"
}

export const PrerequisitesTestAutomation = {
  studyHours: "6 με 8 ώρες διαθέσιμες την βδομάδα για μελέτη",
  programDuration: "Η πιο βασική προϋπόθεση είναι η κατανόηση, ότι είναι ένα υψηλού επιπέδου, τετράμηνο πρόγραμμα σπουδών, όπου για να μπορέσεις να το παρακολουθήσεις, πρέπει να αφιερώσεις χρόνο, αληθινή προσπάθεια και συστηματικότητα.",
  programmingKnowledge:"Προηγούμενη εμπειρία στον προγραμματισμό είναι χρήσιμη αλλά όχι τελείως απαραίτητη"
}